module.exports = __webpack_public_path__ + "img/tb-2.ae878701.png";